import React, { Component } from 'react';
import { Button, TextField, Toolbar } from 'react-md';
import '../Wizard.scss';
import { ProgressBar } from '../../index';
import {  getActiveEmail } from '../../../actions/users.action';

const validateEmail = email => {
  const emailRegex = new RegExp(
    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
  );
  return emailRegex.test(email);
};

export default class PersonWizardStep2 extends Component {
  state = {
    contactString: '',
    inUse: false
  };

  componentDidMount() {
    const { data } = this.props;
    if (data) {
      this.setState({
        contactString: data.contactString
      });
    }
  }

  handleEmailChange = async (value) => {
    const { data } = this.props;
    this.setState({ contactString: value });

    if (validateEmail(value)) {
      this.setState({
        inUse: await getActiveEmail(value) && (data && data.contactString !== value ? true : !data ? true : false)
      });
    } else {
      this.setState({
        inUse: false
      });
    }
  }

  isDisabled = () => {
    return !(validateEmail(this.state.contactString));
  };

  nextStep = () => {
    this.props.actions.update({ contactString: this.state.contactString });
    this.props.nextStep();
  }

  render() {
    const { contactString, inUse } = this.state;
    const { data, title } = this.props;
    const errorMessage = () => {
      if (inUse) {
        return `The email "${contactString}" is already used. Please use a unique email.`;
      }
    };

    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: '36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" icon onClick={this.props.previousStep}>arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} steps={data ? 3 : 4} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">What’s their email address?</div>
          </div>
          <div>
            <TextField
              id="person-email-input"
              className="wizard-text-input"
              label="Email address"
              type="email"
              value={contactString}
              onChange={(v) => this.handleEmailChange(v)}
            />
            <div className="wizard-error">
              {errorMessage()}
            </div>
          </div>
          <div><Button className="wizard-button" disabled={this.isDisabled() || this.state.inUse} flat onClick={this.nextStep} children="continue" /></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/PersonWizardStep2/PersonWizardStep2.jsx